import { EmptyFormsDocument } from 'datasource/useApplicationDetails/ApplicationDetailsManager.types';
import { ApplicationStatus, CaseOrderStatus } from '../../DocBox/DocBox.types';
import { ApplicationDocumentType } from '../AdvisorySection/AdvisorySection.types';

export interface ProductApplicationsProps {
    emptyFormDocuments?: EmptyFormsDocument[];
    applications: SingleApplicationData[];
    isAdvisoryExpired?: boolean;
    is3aVB?: boolean;
    hasDocumentESignAccess?: boolean;
    isAllIdDocumentsSigned?: boolean;
    apiError?: { message: string } | null;
    canCompleteFollowUpInvestorProfileApplication?: boolean;
    hasAccessToReUpload?: boolean;
}

export enum ApplicationTypesEnum {
    NEW = 'ApplicationType.NEW',
    CHANGE = 'ApplicationType.CHANGE',
    SELL = 'ApplicationType.SELL',
    BUY = 'ApplicationType.BUY',
    NEW_EP = 'ApplicationType.NEW.EP',
    CHANGE_EP = 'ApplicationType.CHANGE.EP',
    UPDATE = 'ApplicationType.UPDATE',
}

export interface CaseInvestmentPlan {
    isCaseSource: boolean;
    isSell: boolean;
    amount: number;
}

export interface SingleApplicationData {
    id: number;
    portfolioId: number;
    status: ApplicationStatus;
    typeKey: ApplicationTypesEnum;
    type: string;
    productName?: string;
    productNameTranslated?: string;
    productExternalId?: string;
    applicationId?: number;
    createdDate?: string;
    validTill?: string;
    advisor?: string;
    createdBy?: string;
    investmentAmount?: number;
    depotNumber?: string;
    currentStrategy?: string;
    investedAmount?: number;
    amountToBeSold?: number;
    purchaseAmount?: number;
    submitted?: string;
    submittedBy?: string | undefined;
    partialSaleOrLiquidate?: boolean;
    withTransferDoc?: boolean;
    documents?: ApplicationDocumentType[];
    rubrik?: string;
    canBeDeleted: boolean;
    isSentCase: boolean;
    isSubmissionLocked?: boolean;
    isApplicationExpired?: boolean;
    caseStatus: CaseOrderStatus;
    caseId: number;
    caseInvestmentPlan: CaseInvestmentPlan;
    caseOrderTypeId: number;
    isFollowUpInvestorProfile?: boolean;
    isSubmissionReviewPending?: boolean;
}

export interface SingleApplicationRowProps {
    advisoryDocNotCompleted?: boolean;
    isAdvisoryExpired?: boolean;
    data: SingleApplicationData;
    is3aVB?: boolean;
    hasDocumentESignAccess?: boolean;
    emptyFormDocuments?: EmptyFormsDocument[];
    isAllIdDocumentsSigned?: boolean;
    canCompleteFollowUpInvestorProfileApplication?: boolean;
    hasAccessToReUpload?: boolean;
    apiError?: { message: string } | null;
}
